import React from "react";
import PortalModal from "../../Portals";
import {
  ButtonClose,
  ButtonSend,
  CloseModal,
  ContentForm,
  ContentInstantMessages,
  ContentModal,
  InstantMessage,
  LabelText,
  TextModal,
} from "./ModalInstantMessages.styled";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import BackButtonComponent from "../BackButtonComponent/BackButtonComponent";
import { theme as themeConfig } from "../../themes/themes";

const ModalInstantMessages = ({
  setShowInstantMessagesSOS,
  iceRequestId,
  backTitle,
  locationTitle,
  goToBackPage,
  handleSendInstantMessage,
  listOfInstantMessage,
  handleSelectInstantMessage,
  instantMessageSelected,
  setInstantMessageSelected,
  handleCloseInteraction,
}) => {
  return (
    <PortalModal>
      <ContentModal>
        <div style={{ display: "flex", width: "100%" }}>
          <BackButtonComponent
            backtitle={backTitle}
            locationtitle={locationTitle}
            goToBackPage={goToBackPage}
            titleColor={themeConfig.text.primary}
            titleSize={"18px"}
            titleWeight={"700"}
            titleWidth={"100%"}
            inactiveSlash={true}
            identity={"instantMessages"}
          />
          <CloseModal>
            <Tooltip title="close">
              <IconButton
                onClick={() => {
                  setShowInstantMessagesSOS(false);
                  setInstantMessageSelected([]);
                }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </CloseModal>
        </div>
        <TextModal>
          <hr />
          <LabelText>Select the instant messages to be sent</LabelText>
          <ContentInstantMessages>
            {listOfInstantMessage.map((item, index) => {
              const selected = instantMessageSelected.indexOf(item) !== -1;
              return (
                <InstantMessage
                  key={index}
                  itemSelected={selected}
                  onClick={() => handleSelectInstantMessage(item, !selected)}
                >
                  {item?.message}
                </InstantMessage>
              );
            })}
          </ContentInstantMessages>

          <ContentForm>
            <ButtonSend
              disabled={instantMessageSelected?.length >= 1 ? false : true}
              itemSelected={instantMessageSelected?.length >= 1}
              onClick={() =>
                handleSendInstantMessage(instantMessageSelected, iceRequestId)
              }
            >
              Send
            </ButtonSend>
          </ContentForm>
          <hr />
        </TextModal>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <ButtonClose onClick={() => handleCloseInteraction(iceRequestId)}>
            Close Interaction
          </ButtonClose>
        </div>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalInstantMessages;
